import { useState } from "react";
import { Badge } from "antd";
import { BellOutlined, LogoutOutlined } from "@ant-design/icons";
import { InputText } from "primereact/inputtext";
import { UserHeader } from "../UserHeader/UserHeader";
import { useApplicationContext } from "../../application/ApplicationContext";
import { activeUser } from "../../services/AuthServices";
import { RoleType } from "../../models/Role";
import "./Header.scss";

interface HeaderProps {
  profileImage?: string;
  name: string;
  onNotificationClick: () => void;
  onLogoutClick: () => void;
}

export const Header = (p: HeaderProps) => {
  const { profileImage, name, onNotificationClick, onLogoutClick } = p;

  const { state, setGlobalTextSearch } = useApplicationContext();

  const [searchValue, setSearchValue] = useState<string>(
    state?.globalSearchText ?? ""
  );

  return (
    <div className="header-container">
      <div className="breadcrumb">
        {state?.breadcrumb?.map((breadcrumbItem: string, index: number) => {
          if (state?.breadcrumb?.length === index + 1) {
            return (
              <span key={index} className="breadcrumb-last-item">
                {`${breadcrumbItem}`}
              </span>
            );
          } else {
            return (
              <span
                key={index}
                className="breadcrumb-item"
              >{`${breadcrumbItem} / `}</span>
            );
          }
        })}
      </div>
      <div className="header-user">
        <UserHeader profileImage={profileImage} name={name} />
      </div>
      <div className="header-buttons">
        {/* {activeUser?.role.name !== RoleType.Test && (
          <span className="p-input-icon-right">
            <InputText
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value);
                setGlobalTextSearch(e.target.value);
              }}
              className={"text-input-field p-input-icon-right"}
              placeholder="Unestite tekst za pretragu"
            />
            <i className="pi pi-search" />
          </span>
        )} */}
        {activeUser?.role.name !== RoleType.Test && (
          <div
            className="header-button-notifications"
            onClick={onNotificationClick}
          >
            <Badge count={state.notificationNumber} color="#0D4077">
              <BellOutlined className="header-icon" style={{ fontSize: 28 }} />
            </Badge>
            <p className="header-icon-text">Obaveštenja</p>
          </div>
        )}
        <div className="header-button-notifications" onClick={onLogoutClick}>
          <LogoutOutlined className="header-icon rotation" />
          <p className="header-icon-text logout-text">Logout</p>
        </div>
      </div>
    </div>
  );
};
